import { render, staticRenderFns } from "./pagebutton.vue?vue&type=template&id=50faedb0&scoped=true&"
import script from "./pagebutton.vue?vue&type=script&lang=js&"
export * from "./pagebutton.vue?vue&type=script&lang=js&"
import style0 from "./pagebutton.vue?vue&type=style&index=0&id=50faedb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50faedb0",
  null
  
)

export default component.exports